window.addEventListener("DOMContentLoaded", () => {
	gsap.registerPlugin(ScrollTrigger);

	const root = document.querySelector('#MainContent');
	const pinHeight = root.querySelector('.pin-height');
	const container = root.querySelector('.scroll-container');

	ScrollTrigger.create({
		trigger: pinHeight,
		start: 'top top',
		end: 'bottom bottom',
		pin: container
	});

	let gap = 30;
	const medias = root.querySelectorAll('.media');
	const distPerMedia = (pinHeight.clientHeight - window.innerHeight) / medias.length;

	const titlesWrapper = root.querySelector('.titles');
	let titlesInner = null;
	let titleItems = [];
	let titleItemHeight = 0;

	if (titlesWrapper) {
		titlesInner = document.createElement('div');
		titlesInner.className = 'titles-inner';
		while (titlesWrapper.firstChild) {
			titlesInner.appendChild(titlesWrapper.firstChild);
		}
		titlesWrapper.appendChild(titlesInner);
		titleItems = titlesInner.querySelectorAll('li');
		titleItemHeight = titleItems.length ? titleItems[0].offsetHeight : 0;
	}

	function setActiveTitle(index) {
		if (!titlesInner || !titleItemHeight) return;
		const maxIndex = Math.max(0, Math.min(index, titleItems.length - 1));
		gsap.to(titlesInner, {
			y: -(maxIndex * titleItemHeight),
			duration: 0.4,
			ease: 'power3.out'
		});
	}

	if (titleItems.length) {
		setActiveTitle(0);
	}

	const lastTitle = titleItems.length ? titleItems[titleItems.length - 1] : null;
	const fadeTargets = [lastTitle, ...root.querySelectorAll('[data-fade]')].filter(Boolean);
	const fadeFirstTargets = [...root.querySelectorAll('[data-fade-first]')];

	if (fadeTargets.length) gsap.set(fadeTargets, { opacity: 1 });
	if (fadeFirstTargets.length) gsap.set(fadeFirstTargets, { opacity: 1 });

	gsap.set(medias, {
		y: gap * (medias.length - 1),
		z: -gap * (medias.length - 1)
	});

	medias.forEach((media, index) => {
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: pinHeight,
				start: 'top top+=' + (distPerMedia * index),
				end: 'bottom bottom+=' + (distPerMedia * index),
				scrub: 0.5
			}
		});

		for (let i = 0; i < medias.length - 1; i++) {
			tl.to(media, {
				y: "-=" + gap,
				z: "+=" + gap,
				ease: 'back.inOut(3)'
			});
		}

		tl.to(media, {
			yPercent: -80,
			y: '-50vh',
			scale: 1.2,
			rotation: (Math.random() - 0.5) * 50,
			ease: 'power4.in'
		});
	});

	if (titlesInner && titleItems.length && medias.length) {
		const total = Math.min(medias.length, titleItems.length);

		ScrollTrigger.create({
			trigger: pinHeight,
			start: 'top top',
			end: 'bottom bottom',
			onUpdate(self) {
				const rawIndex = Math.floor(self.progress * total);
				const index = Math.max(0, Math.min(rawIndex, total - 1));
				setActiveTitle(index);

				if (fadeTargets.length) {
					const atEnd = self.progress >= 0.98;
					gsap.to(fadeTargets, {
						opacity: atEnd ? 0 : 1,
						duration: 0.2,
						ease: 'power2.out'
					});
				}

				if (fadeFirstTargets.length) {
					const pastStart = self.progress >= 0.02;
					gsap.to(fadeFirstTargets, {
						opacity: pastStart ? 0 : 1,
						duration: 0.2,
						ease: 'power2.out'
					});
				}
			}
		});
	}

	gsap.to(pinHeight, {
		opacity: 1,
		duration: 0.4,
		ease: "power2.out"
	});
});
